export default {

  state: {
    layout: 'loading'  //loading, admin, blank
  },

  mutations: {
    setLayout(state, payload) {
        state.layout = payload;
    }
  },

  getters: {
    getLayout(state) {
        return state.layout;
    }
  }
  
}